import React from 'react';
import { reviewQueries } from './index';
import { useQueryData } from '../apollo/query';
import {
  IReview,
  IReviewListInput,
  IResponseReviewList,
  IQueryGetReviewListArgs,
  ISortDirection,
  IModelReviewFilterInput,
} from 'types/types';

type UseGetReviewList = (
  courseId: string,
  limit?: number,
) => {
  loading: boolean;
  hasMore?: boolean;
  filter: IReviewListInput;
  reviews: IReview[];
  page: number;
  totalPages: number;
  rowPerPage: number;
  onChangePage: (page: number) => void;
  onSearch: (keyword: string) => void;
};

export const useGetReviewList: UseGetReviewList = (courseId, limit) => {
  const [filter, setFilter] = React.useState<IReviewListInput>({
    page: 1,
    sortDirection: ISortDirection.Asc,
    limit: limit || 10,
    filter: { courseId },
  } as IReviewListInput);

  const [getReviewList, { data: dataList, loading: loadingList }] = useQueryData<
    { getReviewList: IResponseReviewList },
    IQueryGetReviewListArgs
  >({
    table: 'review',
    action: 'list',
    tData: 'getReviewList',
    fetchPolicy: 'cache-and-network',
    query: reviewQueries.LIST,
  });

  React.useEffect(() => {
    getReviewList({ variables: { input: filter } });
  }, [filter]);

  function onChangePage(page: number) {
    setFilter({ ...filter, page: page });
  }

  function onSearch(keyword: string) {
    setFilter({ ...filter, filter: { keyword } as IModelReviewFilterInput });
  }

  const hasMore =
    dataList?.getReviewList && Boolean(dataList?.getReviewList?.page < dataList?.getReviewList?.totalPages);

  return {
    loading: !dataList?.getReviewList?.results && loadingList,
    filter,
    page: filter.page,
    totalPages: dataList?.getReviewList.totalPages || 1,
    rowPerPage: filter.limit,
    hasMore,
    reviews: (dataList?.getReviewList.results || []) as IReview[],
    onChangePage,
    onSearch,
  };
};
